<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsPartnerDisclosureTitle')"
    [headerImage]="config.logo"
    customMaxWidth="552px"
    size="large"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p id="partner-disclosure-modal-text" class="text-ld-neutral-700 font-dm text-base leading-6 mb-4">
        {{ t(config.translationKeyPrefix + 'DisclosureText') }}
      </p>

      <p id="partner-disclosure-modal-redirect" class="text-ld-neutral-700 font-dm text-base leading-6 mb-4">
        {{ t('modalsPartnerDisclosureClickText') }}
        <strong>{{ t(config.confirmButtonKey) }}</strong>
        {{ t('modalsPartnerDisclosureRedirectText', { partnerName: config.name }) }}
      </p>

      @if (config.disclaimerFootnoteKey) {
        <p class="text-ld-neutral-500 font-dm text-sm leading-5 mb-4">
          {{ t(config.disclaimerFootnoteKey) }}
        </p>
      }

      <p id="partner-disclosure-modal-disclaimer" class="text-ld-neutral-500 font-dm text-sm leading-5">
        @if (config.disclaimerTextBeforeKey) {
          {{ t(config.disclaimerTextBeforeKey) }}
          @if (config.privacyPolicyUrl) {
            <a
              [id]="'partner-disclosure-modal-privacy-link'"
              [href]="config.privacyPolicyUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t(config.privacyLinkKey ?? 'commonLinksPrivacyPolicy') }}
            </a>
          }
          @if (config.termsUrl) {
            {{ t('commonAnd') }}
            <a
              [id]="'partner-disclosure-modal-terms-link'"
              [href]="config.termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t(config.termsLinkKey ?? 'commonLinksTermsOfUse') }}
            </a>
          }
          @if (config.disclaimerTextAfterKey) {
            {{ t(config.disclaimerTextAfterKey) }}
          }
        } @else {
          {{ t(config.translationKeyPrefix + 'DisclaimerText') }}
          @if (config.privacyPolicyUrl) {
            <a
              [id]="'partner-disclosure-modal-privacy-link'"
              [href]="config.privacyPolicyUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t('commonLinksPrivacyPolicy') }}
            </a>
          }
          @if (config.termsUrl) {
            <span>{{ t('commonAnd') }}</span>
            <a
              [id]="'partner-disclosure-modal-terms-link'"
              [href]="config.termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t('commonLinksTermsOfUse') }}
            </a>
          }
        }
      </p>
    </div>
    <div modal-footer>
      <button id="partner-disclosure-modal-cancel" type="button" class="btn-outline-ld-purple" (click)="onCancel()">
        {{ t('commonButtonsCancel') }}
      </button>
      <button id="partner-disclosure-modal-confirm" type="button" class="btn-primary-ld-purple" (click)="onConfirm()">
        {{ t(config.confirmButtonKey) }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
